import React, { useState, useEffect } from 'react';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import AdminDeptNavBar from '../../../../layouts/admin-department/AdminDeptNavBar';
import JobOpeningsForm from './JobOpeningsForm';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../../../../utils/config';

const JobOpenings = () => {
  const {
    profile: { firstName },
  } = useUser();
  const [jobOpenings, setJobOpenings] = useState([]);
  const [selectedCareer, setSelectedCareer] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        const token = sessionStorage.getItem('token');
        const res = await axios.get(`${API_URL}/careers`, {
          headers: { Authorization: `Bearer ${token}` },
        });




        console.log('careers fetched', res.data);
        setJobOpenings(res.data || []);
      } catch (err) {
        toast.error('Failed to load careers');
        console.error('fetchCareers error', err);
      }
    };

    fetchCareers();
  }, []);

  const handleEdit = (career) => {
    setSelectedCareer(career);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this career posting?')) return;
    try {
      const token = sessionStorage.getItem('token');
      await axios.delete(`${API_URL}/careers/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setJobOpenings((prev) => prev.filter((c) => c.id !== id));
      toast.success('Career deleted');
    } catch (err) {
      const errMsg = err && err.response && err.response.data && err.response.data.message
        ? err.response.data.message
        : 'Failed to delete career';
      toast.error(errMsg);
      console.error('delete career error', err);
    }
  };

  const handleSaved = (career, isUpdate) => {
    if (isUpdate) {
      setJobOpenings((prev) => prev.map((c) => (c.id === career.id ? career : c)));
    } else {
      setJobOpenings((prev) => [career, ...prev]);
    }
    setSelectedCareer(null);
    setShowModal(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCareer(null);
    if (document.body) {
      document.body.style.overflow = '';
    }
  };

  const openModalHandler = () => {
    setSelectedCareer(null);
    setShowModal(true);
    if (document.body) {
      document.body.style.overflow = 'hidden';
    }
  };

  useEffect(() => {
  const fn = () => console.log("PAGE RELOADING...");
  window.addEventListener("beforeunload", fn);
  return () => window.removeEventListener("beforeunload", fn);
}, []);


  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AdminDeptNavBar currentPage="Job Openings" position={firstName} />
        <div className="container-fluid p-5">
          <div className="row mb-4 pt-5">
            <div className="col-12 d-flex justify-content-between align-items-center pt-2">
              
              <button
              type="button"
              className="btn btn-success btn-lg"
              onClick={openModalHandler}
            >
              + Create New Job Opening
            </button>
            </div>
          </div>

          <div className="card shadow">
            <div className="card-header bg-light">
              <h5 className="mb-0">Existing Careers ({jobOpenings.length})</h5>
            </div>
            <div className="card-body p-0">
              {jobOpenings && jobOpenings.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Title</th>
                        <th>Department</th>
                        <th>Location</th>
                        <th>Type</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobOpenings.map((c) => (
                        <tr key={c.id}>
                          <td className="fw-bold">{c.title}</td>
                          <td>{c.department}</td>
                          <td>{c.location}</td>
                          <td>{c.employment_type}</td>
                          <td>
                            <button className="btn btn-sm btn-info me-3" onClick={() => handleEdit(c)}>
                              Edit
                            </button>
                            <button className="btn btn-sm btn-danger mt-2" onClick={() => handleDelete(c.id)}>
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="p-4 text-center text-muted">
                  <p>No job openings yet. Create one to get started!</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      {showModal && (
  <>
    {/* Backdrop */}
    <div
      onClick={handleCloseModal}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        backdropFilter: "blur(4px)",
        zIndex: 1040,
      }}
    />

    {/* Modal Wrapper */}
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      {/* Modal Card */}
      <div
        className="bg-white"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: "900px",
          borderRadius: "16px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          overflow: "hidden",
          animation: "fadeInScale 0.18s ease-out",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "16px 20px",
            background: "#f8fafc",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "sticky",
            top: 0,
            zIndex: 2,
          }}
        >
          <div>
            <h5 style={{ margin: 0, fontWeight: 700, color: "#0f172a" }}>
              {selectedCareer ? "Edit Job Opening" : "Create New Job Opening"}
            </h5>
            <small style={{ color: "#64748b" }}>
              Fill in the details below and save.
            </small>
          </div>

          <button
            type="button"
            onClick={handleCloseModal}
            style={{
              border: "none",
              background: "transparent",
              width: 38,
              height: 38,
              borderRadius: 10,
              display: "grid",
              placeItems: "center",
              cursor: "pointer",
              color: "#0f172a",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "rgba(15, 23, 42, 0.06)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "transparent")
            }
            aria-label="Close"
          >
            <span style={{ fontSize: 20, lineHeight: 1 }}>✕</span>
          </button>
        </div>

        {/* Body */}
        <div
          style={{
            padding: "18px 20px",
            maxHeight: "75vh",
            overflowY: "auto",
          }}
        >
          <JobOpeningsForm
            jobOpenings={jobOpenings}
            setJobOpenings={setJobOpenings}
            selectedCareer={selectedCareer}
            onSaved={handleSaved}
            onCancel={handleCloseModal}
            isModal={true}
          />
        </div>
      </div>

      {/* Animation keyframes */}
      <style>
        {`
          @keyframes fadeInScale {
            from {
              opacity: 0;
              transform: translateY(8px) scale(0.98);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }
        `}
      </style>
    </div>
  </>
)}

    </div>
  );
};

export default JobOpenings;
